export default {
  selectedFacilitiesIds: state => state.selectedFacilities.map(({ id }) => id),
  initiallySelectedFacilitiesIds: state =>
    state.initiallySelectedFacilities.map(({ id }) => id),
  selectedFacilitiesCount: state => state.selectedFacilities.length,
  gmbAddressesIds: state => state.selectedFacilities.map(i => i.gmb_address_id),
  facilitiesIds: state => state.selectedFacilities.map(i => i.id),
  isAllFacilitiesSelected: (state, getters) => {
    const selectedIds = getters.selectedFacilitiesIds;
    return state.allFacilitiesIds
      .map(({ id }) => id)
      .every(id => selectedIds.includes(id));
  },
  isAllCurrentPageFacilitiesSelected: (state, getters) => {
    const selectedIds = getters.selectedFacilitiesIds;
    return state.currentPageFacilities
      .filter(
        i =>
          i.facilityListings &&
          i.facilityListings.isOwner &&
          i.facilityListings.addressGroup &&
          i.facilityListings.addressGroup.gmbAddressId !== null // case for "adding to Google Maps"
      )
      .every(({ id }) => selectedIds.includes(id));
  },
  isAllFacilitiesInitiallySelected: (state, getters) => {
    return state.allFacilitiesIds
      .map(({ id }) => id)
      .every(id => getters.initiallySelectedFacilitiesIds.includes(id));
  },
  isAllCurrentPageFacilitiesInitiallySelected: (state, getters) => {
    return state.currentPageFacilities
      .filter(i => i.facilityListings)
      .every(({ id }) => getters.initiallySelectedFacilitiesIds.includes(id));
  },
  isFacilitySelected: state => facilityId =>
    state.selectedFacilities.findIndex(({ id }) => id === facilityId) > -1,
  isFacilityInitiallySelected: (state, getters) => facilityId =>
    getters.initiallySelectedFacilitiesIds.includes(facilityId)
};
